import { render, staticRenderFns } from "./cardBillDetail.vue?vue&type=template&id=0f28b98e&"
import script from "./cardBillDetail.vue?vue&type=script&lang=js&"
export * from "./cardBillDetail.vue?vue&type=script&lang=js&"
import style0 from "./cardBillDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports